// Główny moduł JS
import { gsap } from 'gsap'

// =============================================
// MOBILE MENU TOGGLE
// =============================================

document.addEventListener('DOMContentLoaded', () => {
    const menuToggle = document.getElementById('menuToggle');
    const mobileNav = document.getElementById('mobileNav');

    if (menuToggle && mobileNav) {
        menuToggle.addEventListener('click', () => {
            menuToggle.classList.toggle('is-active');
            mobileNav.classList.toggle('is-active');
        });

        // Close menu when clicking on a link
        const mobileLinks = mobileNav.querySelectorAll('.header__mobile-link');
        mobileLinks.forEach(link => {
            link.addEventListener('click', () => {
                menuToggle.classList.remove('is-active');
                mobileNav.classList.remove('is-active');
            });
        });
    }
});
